import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 45000-45999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const notificationsErrors = {
  // 45xxx notifications. Its "Portal not found" site reused PORTAL_NOT_FOUND.
  PUSH_NO_ACTIVE_SESSION: {
    errorCode: 45001,
    errorMessage: t("No active session for push registration"),
    isDynamic: false,
  },
  NOTIFICATION_IDS_OR_DATE_RANGE_REQUIRED: {
    errorCode: 45002,
    errorMessage: t("Pass notification ids or a date range to mark as read."),
    isDynamic: false,
  },
  NOTIFICATION_IDS_REQUIRED: {
    errorCode: 45003,
    errorMessage: t("Pass at least one notification id."),
    isDynamic: false,
  },
  PUSH_TOKEN_INVALID: {
    errorCode: 45004,
    errorMessage: t("Invalid Expo push token"),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
